<i class="fal fa-info-circle"
   #target></i>

<dx-popover [target]="tooltipTarget ?? target"
            showEvent="dxhoverstart"
            [hideEvent]="{ name: 'dxhoverend', delay: 300 }"
            [(visible)]="popoverVisible"
            (onHiding)="onPopoverHiding($event)"
            height="auto"
            maxHeight="70vh"
            [maxWidth]="400">
    <div *dxTemplate="let data of 'content'"
         class="p-2 d-flex flex-column gap-2"
         (pointerenter)="preventHide()"
         (pointerleave)="allowHide()"
         (pointerdown)="allowHide()">
        <div>
            This
            {{ culturalActivityTypeMetadata.shortTitle.toLocaleLowerCase() }}
            has been rescheduled{{ !activity.supplementaryData?.comment ? "." : " with the following comment:" }}
        </div>

        @if (activity.supplementaryData?.comment) {
            <div [froalaView]="activity.supplementaryData?.comment"></div>
        }

        @if (showOriginalDate) {
            <hr class="m-0" />
            <div class="text-muted">Original date: {{ activity.initialDate | adaptDate }}</div>
        }
    </div>
</dx-popover>
